import { Directive } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromRootStore from '@apps/root/store';
import { IAuroraState } from '@apps/aurora.state';

@Directive()
export class ChipsStateListenerComponent
{
    public chipsState: Observable<boolean>;

    constructor (
        protected store: Store<IAuroraState>
    )
    {
        this.chipsState = this.store.select(fromRootStore.getChipsStatus);
    }
}
